<template>
  <el-form
    v-loading.fullscreen.lock="fullscreenLoading"
    ref="formOpportunity"
    :model="model"
    :rules="rules"
    label-position="top"
    class="padding-20"
    @submit.native.prevent="onSubmit">
    <el-row>
      <el-col :span="24">
        <el-form-item
          label="Título:"
          prop="title">
          <el-input
            v-model="model.title"
            placeholder="Escriba el título"/>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item
          label="Descripción:"
          prop="description">
          <el-input
            v-model="model.description"
            :rows="4"
            resize="none"
            type="textarea"/>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Tipo:"
          prop="type">
          <el-select
            v-model="model.type"
            disabled>
            <el-option
              v-for="(type, index) in types"
              :key="index"
              :label="type.label"
              :value="type.value"/>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Estatus:"
          prop="status">
          <el-select
            v-model="model.status"
            disabled>
            <el-option
              v-for="(state, index) in status"
              :key="index"
              :label="state.name"
              :value="state.name"/>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Tipo de maquinaria"
          prop="machineryType">
          <el-select
            v-model="model.machineryType"
            placeholder="Elija un tipo">
            <el-option
              v-for="(type, index) in typesMachinery"
              :key="index"
              :label="type.name"
              :value="type.name"/>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Marca"
          prop="brand">
          <el-autocomplete
            v-model="model.brand"
            :fetch-suggestions="fetchBrands"
            placeholder="Escriba una marca"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Modelo"
          prop="model">
          <el-autocomplete
            v-model="model.model"
            :fetch-suggestions="fetchModels"
            placeholder="Escriba el modelo"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Cantidad"
          prop="quantity">
          <el-input-number
            v-model="model.quantity"
            :min="1"
            :max="20"/>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button
          type="primary"
          native-type="submit">
          Guardar
        </el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import opportunityModel from '@/models/opportunities/opportunities-model'
import http from '@/services/http.service'
import { mapActions } from 'vuex'

export default {
  name: 'OpportunitiesForm',
  props: {
    old: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isEdit: false,
      model: opportunityModel.model(),
      rules: opportunityModel.rules(),
      types: [
        {
          label: 'Venta',
          value: 'SALE'
        }
      ],
      status: [],
      typesMachinery: [],
      brands: [],
      models: [],
      fullscreenLoading: false
    }
  },
  mounted () {
    if (this.old !== null) {
      this.isEdit = true
      this.model = Object.assign({}, this.model, this.old)
      http
        .get(process.env.API_URL + 'opportunity-status?limit=1000')
        .then(response => {
          this.status = response.data.items
        }).catch(error => {
          return Promise.reject(error)
        })
      http
        .get(process.env.API_URL + 'machinery-types')
        .then(response => {
          this.typesMachinery = response.data.items
        }).catch(error => {
          return Promise.reject(error)
        })
      http
        .get(process.env.API_URL + 'brands')
        .then(response => {
          this.typesMachinery = response.data.items
        }).catch(error => {
          return Promise.reject(error)
        })
    } else {
      http
        .get(process.env.API_URL + 'opportunity-status?limit=1000')
        .then(response => {
          this.status = response.data.items
        }).catch(error => {
          return Promise.reject(error)
        })
      http
        .get(process.env.API_URL + 'machinery-types')
        .then(response => {
          this.typesMachinery = response.data.items
        }).catch(error => {
          return Promise.reject(error)
        })
      http
        .get(process.env.API_URL + 'brands')
        .then(response => {
          this.brands = response.data.items
        }).catch(error => {
          return Promise.reject(error)
        })
    }
  },
  methods: {
    ...mapActions('opportunities', ['save']),
    mountedModels () {
      http
        .get(process.env.API_URL + 'brands?filters[where][name][eq]=' + this.model.brand + '&limit=1000')
        .then(response => {
          http
            .get(process.env.API_URL + 'models?filters[where][brandId][eq]=' + response.data.items[0].id + '&limit=1000')
            .then(response => {
              response.data.items.forEach((item) => {
                this.models.push(item)
              })
            }).catch(error => {
              return Promise.reject(error)
            })
        }).catch(error => {
          return Promise.reject(error)
        })
    },
    onSubmit () {
      // this.$route.reload()
      this.$refs['formOpportunity'].validate((valid) => {
        this.model.customerId = this.customer.id
        if (valid) {
          this.save(this.model).then(response => {
            this.$notify.success({
              group: 'app',
              title: 'Oportunidad creada.',
              message: 'La oportunidad se creo correctamente'
            })
            this.$store.dispatch('opportunities/query', {
              'filters[where][customerId][eq]': this.customer.id
            })
              .then(({data}) => {
                this.$store.dispatch('app/toggleOpportunityPanel')
                return this.$router.push({...this.$route, name: 'customers-opportunity-table'})
              })
          }).catch(error => {
            this.$notify.error({
              group: 'app',
              title: 'Error al crear la oportunidad.',
              message: 'Por favor, vuelve a intentarlo.'
            })
            return Promise.reject(error)
          })
          this.fullscreenLoading = true
          setTimeout(() => {
            this.fullscreenLoading = false
          }, 2000)
        } else {
          this.$notify.error({
            group: 'app',
            title: 'Verifica el formulario.',
            message: 'Por favor, revisa los errores que se indican dentro del formulario.'
          })
          return false
        }
      })
    },
    fetchModels (queryString, cb) {
      let results = []
      http.get('brands', {params: {
        'filters[where][name][eq]': this.model.brand
      }}).then(({data}) => {
        http.get('models', {params: {
          'filters[where][brandId][eq]': data.items[0].id,
          'filters[where][name][contains]': queryString,
          limit: 1000
        }}).then(({data}) => {
          for (let item of data.items) {
            results.push({
              label: item.name,
              value: item.name
            })
          }
          cb(results)
        })
      })
    },
    fetchBrands (queryString, cb) {
      let results = []
      http.get('brands', {params: {
        'filters[where][name][contains]': queryString,
        limit: 1000
      }}).then(({data}) => {
        for (let item of data.items) {
          results.push({
            label: item.name,
            value: item.name
          })
        }
        cb(results)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-button {
  background-color: $primary;
  color: #ffffff;
  width: 100%;
  box-shadow: 0 3px 6px 0 rgba(231, 18, 14, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/modules/opportunities/opportunities-form.vue